export default __webpack_public_path__ + "presaleaa61ac.png";